export default __webpack_public_path__ + "static/3-e5ad9f3cd02f8e940b98a1df0a9a9226.svg";